import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import View from '../../../../../components/pdf/View'
import { Paragraph, SectionHeading } from './_shared/Prose'

/**
 * Seção 17 - Gestão de Empresas Terceiras. Texto literal do modelo aprovado por Julia
 * Buzzo ("Modelo PGR 2026 - Banco Bradesco_Varejo"). Substitui o placeholder
 * institucional anterior (arquivo era `17.RevisaoProgramaSection.js` — o conteúdo de
 * revisão do programa é a Seção 16, ver `16.RegistroControleAvaliacaoRevisaoSection.js`).
 */
const GestaoEmpresasTerceirasSection = () => (
  <View id="17">
    <Separator weight={15} />
    <SectionHeading numero={17}>GESTÃO DE EMPRESAS TERCEIRAS</SectionHeading>

    <Paragraph>
      A gestão de empresas terceiras no contexto do Programa de Gerenciamento de Riscos (PGR) exige uma abordagem
      colaborativa e bem estruturada. É entendido que a contratante garanta que todas as atividades realizadas em
      seu ambiente estejam em conformidade com as normas de segurança, contudo, é fundamental reconhecer que cada
      empresa terceira é responsável por elaborar e implementar seu próprio PGR, considerando os riscos específicos
      de suas atividades.
    </Paragraph>

    <Paragraph>
      Esses PGRs próprios devem conter o inventário de riscos ocupacionais e o plano de ação correspondente,
      conforme exigido pela NR-01. Cabe à contratante verificar se os documentos estão atualizados, se contemplam os
      riscos reais das atividades executadas e se as medidas de controle propostas são compatíveis com o ambiente
      onde serão aplicadas.
    </Paragraph>

    <Paragraph>
      A cultura de segurança precisa ser compartilhada e reforçada continuamente, promovendo um ambiente
      colaborativo e seguro para todos os envolvidos.
    </Paragraph>

    <Separator weight={15} />
  </View>
)

export default GestaoEmpresasTerceirasSection
